import ETSLogo from "../../../static/svgs/ets-simple-logo.svg";
import React, { useState} from "react";
import CarnegieFoundationLogo from "../../../static/svgs/carnegie-foundation-logo.svg";
import { removeDataFromLocalStorage } from "utils";
import { logout } from "redux/slices/accountSlice";
import { signOut } from "aws-amplify/auth";
import { cn } from "utils/cn";
import { useDispatch, useSelector } from "react-redux";
import authService from "services/authService";
import { useNavigate } from "react-router-dom";

type HeaderNavTab = {
  label: string;
  to: string;
}

interface HeaderNavProps {
  showTabs?: boolean;
  tabs?: HeaderNavTab[];
  showButtons?: boolean;
  onEmailButtonClick?: () => void;
  onLeaveButtonClick?: () => void; 
};

const HeaderNav = ({
  showTabs,
  tabs,
  showButtons = true, 
  onEmailButtonClick = () => {},
  onLeaveButtonClick = () => {}
}: HeaderNavProps) => {
  const { id } = useSelector((state: any) => state.account);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleMail = () => {
    const email = "SFFsupport@ets.org";
    const mailtoLink = `mailto:${email}`;
    window.location.href = mailtoLink;
  }

  const handleLogout = async () => {
    try {
      sessionStorage.removeItem("user");
      sessionStorage.removeItem("token");
      removeDataFromLocalStorage(`dropDownValue_${id}`)
      try {
        await signOut();
      } catch (error) {
        console.log('error signing out: ', error);
      }
      let resp = authService.logout();
      dispatch(logout());
      navigate("/login");
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <div className="flex h-[58px] my-[13px] pl-[43px] pr-[59px] w-full items-center border border-primary-teal bg-background-paleTeal rounded-lg">
      <img src={ETSLogo} alt="ETS Logo" />

      <div className="border-l border-typography-charcoal h-[28px] mx-3" />

      <img src={CarnegieFoundationLogo} alt="Carnegie Foundation Logo" />

      <div className="grow">
        {
          showTabs && tabs && tabs.map((tab) => {
            return (
              <div className="h-full flex items-center px-[28px]">
                <p>{tab.label}</p>
              </div>
            );
          })
        }
      </div>

      <button 
        className={cn(
          "mr-4",
          !showButtons ? "hidden" : "",
        )} 
        onClick={() => {
          onEmailButtonClick();
          handleMail()
        }}
      >
        <i className="fa-regular fa-envelope text-typography-charcoal w-[20px] h-[16px]" />
      </button>

      <button
        onClick={() => {
          onLeaveButtonClick();
          handleLogout();
        }}
        className={!showButtons ? "hidden" : "" }
      >
        <i className="fa-solid fa-arrow-right-from-bracket" />
      </button>
    </div>
  )
};

export default HeaderNav;
